import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
import { Static } from "components/atoms";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store";
import { useEffect } from "react";
import { LogLevel, log } from "utils/LogUtil";
import AccountPage from "./Account";
import TrashPage from "./Trash";
import BillingPage from "./Billing";
import AIReviewsPage from "./AIReviews";
import { eventLog } from "utils/AmplitudeUtil";
import SideNavigation from "components/templates/MyPageTemplate/SideNavigation";
import CommonHeader from "components/organisms/CommonHeader";
import styled from "styled-components";
import { withPageGuard } from "components/common/withPageGuard";

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 100%;
  background: #f7fafd;
`;

const HeaderWrapper = styled.div`
  position: sticky;
  top: 0;
  z-index: 1000;
  background: #ffffff;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex: 1;
`;

const MyPage = () => {
  const user = useSelector((state: RootState) => state.user.user);
  const navigate = useNavigate();

  useEffect(() => {
    eventLog("마이페이지_진입", {});
    log(LogLevel.VERBOSE, "MyPage: mounted");
  }, []);

  useEffect(() => {
    log(LogLevel.VERBOSE, "MyPage: useEffect user", user);
    if (!user) {
      navigate("/login");
    }
  }, [user]);

  log(LogLevel.VERBOSE, "MyPage: render", [user]);

  return (
    <PageContainer>
      <HeaderWrapper>
        <CommonHeader withoutPath={true} logoNavigate={true} />
      </HeaderWrapper>
      <ContentWrapper>
        <SideNavigation />
        <Static customStyle={{ flexGrow: 1 }}>
          <Routes>
            <Route path="" element={<Navigate to="accounts" replace />} />
            <Route path="ai-reviews" element={<AIReviewsPage />} />
            <Route path="orders" element={<Navigate to="/mypage/billing?tab=payments" replace />} />
            <Route path="points" element={<Navigate to="/mypage/billing?tab=pricing" replace />} />
            <Route path="pricing" element={<Navigate to="/mypage/billing?tab=pricing" replace />} />
            <Route path="billing" element={<BillingPage />} />
            <Route path="accounts" element={<AccountPage />} />
            <Route path="trash" element={<TrashPage />} />
          </Routes>
        </Static>
      </ContentWrapper>
    </PageContainer>
  );
};

// 마이페이지는 로그인과 약관 동의가 필요
export default withPageGuard(MyPage, {
  requireAuth: true,
  requireAgreement: true,
});
